import { TDeviceFormFactor } from '@core/js/hooks/device/store/types';
import { TGamesGridLayoutSize, IGameTileAssetLayout, IGame, LAYOUT_SIZES } from '@theme/js/hooks/games/types';

import { TGameRatio } from '@core/js/components/main/GamesGrid/types';

export const getGameImage = ({ game, isLoggedIn, size, formFactor, ratio }: {
    game: IGame;
    ratio: TGameRatio;
    isLoggedIn: boolean;
    formFactor: TDeviceFormFactor;
    size: TGamesGridLayoutSize;
}): string => {
    let gameTileAssets: IGameTileAssetLayout = {} as IGameTileAssetLayout;

    switch (size) {
        case LAYOUT_SIZES.landscape:
            gameTileAssets = game.gameTileAssetsLandscape;

            break;
        case LAYOUT_SIZES.portrait:
            gameTileAssets = game.gameTileAssetsPortrait;

            break;
        case LAYOUT_SIZES.square:
            gameTileAssets = game.gameTileAssetsSquare;

            break;
        default:
            break;
    }

    const layout = gameTileAssets[ratio] || {};
    const mainGameImage = isLoggedIn ? layout.mainImage : layout.guestMainImage || layout.mainImage;
    const userMobileImage = layout.mobileImage || layout.mainImage;
    const mobileGameImage = isLoggedIn ? userMobileImage : layout.guestMobileImage || layout.guestMainImage || userMobileImage;

    if (formFactor === 'desktop') {
        return mainGameImage || game.defaultGameImage;
    }

    return mobileGameImage || game.defaultGameImage;
};
